module.exports = "<div class=\"wrapper\" style=\"background:url(assets/img/bg_2.png)  repeat-x bottom;background-color: #fff;\">\n  <app-header-public></app-header-public>\n\n  <!--  <app-sidebar></app-sidebar> -->\n  <!-- Main content -->\n\n  <router-outlet></router-outlet>\n  \n  <!-- <app-aside></app-aside> -->\n</div>\n<app-footer-public></app-footer-public>"


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/src/app/containers/full-layout-public/full-layout-public.component.html
// module id = ../../../../../src/app/containers/full-layout-public/full-layout-public.component.html
// module chunks = main